import { render, staticRenderFns } from "./PqPending.vue?vue&type=template&id=5fd52a8e&scoped=true&"
import script from "./PqPending.vue?vue&type=script&lang=js&"
export * from "./PqPending.vue?vue&type=script&lang=js&"
import style0 from "./PqPending.vue?vue&type=style&index=0&id=5fd52a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd52a8e",
  null
  
)

export default component.exports